// assets
import { IconCloudUpload, IconDashboard, IconDeviceAnalytics} from '@tabler/icons';
import { IconBrandFramer, IconTypography, IconPalette, IconShadow, IconWindmill, IconLayoutGridAdd, IconArrowsLeftRight, IconUsers} from '@tabler/icons';

// constant
const icons = {
    IconDashboard: IconDashboard,
    IconCloudUpload: IconCloudUpload,
    IconDeviceAnalytics,
    IconTypography: IconTypography,
    IconPalette: IconPalette,
    IconShadow: IconShadow,
    IconWindmill: IconWindmill,
    IconBrandFramer: IconBrandFramer,
    IconLayoutGridAdd: IconLayoutGridAdd,
    IconArrowsLeftRight,
    IconUsers
};

//-----------------------|| DASHBOARD MENU ITEMS ||-----------------------//

export const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Dữ liệu hóa đơn',
            type: 'item',
            url: '/dashboard/invoice',
            icon: icons['IconFileInvoice'],
            breadcrumbs: false
        }
    ]
};
